import React, { useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import type { MessageArgsProps, UploadProps } from "antd";
import { message, Upload } from "antd";
import { uploadCSV } from "../../network/clients";
import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import queryClient from "../../services/react-query/queryClient";
import { queryKeys } from "../../services/react-query/queryKeys";

const { Dragger } = Upload;

const UploadFile = ({ close }: any) => {
  const [uploadError, setUploadError] = useState<boolean>(false);
  const { mutate: onFileUpload, isLoading: isFileUploading } = useMutation(
    uploadCSV,
    {
      onSuccess: (res: any) => {
        // Handle successful file upload
        console.log(res);

        if (
          res?.code === "ERR_BAD_RESPONSE" ||
          res?.code === "ERR_BAD_REQUEST"
        ) {
          message.error(res.response.data.message);
        } else if (res?.data?.data.rows_not_import.length > 0) {
          res?.data?.data.rows_not_import.map((e: any) =>
            message.warning(`row ${e.row} ${e.message}`)
          );

          close();
        } else {
          message.success(`File uploaded and processed successfully.`);
          close();
        }
        queryClient.invalidateQueries([queryKeys.listClient]);
        // Additional logic if needed
      },
      onError: (error: any) => {
        // Handle error during file upload
        console.log(error);
        message.error("File upload error:", error);
        // Additional error handling if needed
      },
    }
  );

  const handleFileUpload = (file: any) => {
    const formData = new FormData();
    formData.append("file", file);
    console.log("done2");
    onFileUpload(formData);
  };
  const props = {
    name: "file",
    maxCount: 1,
    // Removed action property to disable automatic uploads
    beforeUpload(file: any) {
      const isCSV = file.type === "text/csv";
      if (!isCSV) {
        setUploadError(true);
        message.error("Please upload a CSV file.");
        return Upload.LIST_IGNORE; // Prevent upload and listing of non-CSV files
      }
      setUploadError(false);
      return false; // Prevent automatic upload, but allow the file to be listed
    },
    onChange(info: any) {
      console.log(info);
      handleFileUpload(info.file);
    },
  };
  const intl = useIntl();

  return (
    <Dragger
      {...props}
      className={uploadError ? "ant-upload-dragger-error" : ""}
    >
      <div className="flex items-center justify-center w-full text-center">
        <span className="bg-color-primary px-2 py-[0.2rem] rounded-full text-white text-xs text-center">
          2
        </span>
      </div>
      <div className="bg-[#EEF0FF] w-full grid p-8 gap-6">
        <span className="text-sm font-semibold">
          {intl.formatMessage({
            id: "bulkFileTitle",
          })}
        </span>
        <div className="flex items-center justify-center gap-[10px] py-2 px-6 border-[1px] border-solid w-fit mx-auto rounded-lg border-[#75757E]">
          <InboxOutlined style={{ fontSize: "19px", color: "#9999A7" }} />
          <span className="text-[#75757E]">
            {intl.formatMessage({
              id: "selectFileFromDevice",
            })}
          </span>
        </div>
        <span className="text-xs font-normal text-[#75757E]">
          {intl.formatMessage({
            id: "bulkFileSubTitle",
          })}
        </span>
      </div>
    </Dragger>
  );
};

export default UploadFile;
